import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLayout} from '../../hooks/useLayout';
import {usePreloadSlideImages} from '../../hooks/usePreloadSlideImages';
import {clockTickAction} from '../../store/actions/chalkBoardElements.actions';
import ImageMarkupProvider from '../element/types/question/imageMarkup/ImageMarkupContext';
import {PresentationViewDesktop} from './PresentationViewDesktop';
import {PresentationViewMobile} from './PresentationViewMobile';
import SlideRefContextProvider from '../../context/SlideRefContext';

function PresentationView(): JSX.Element {
    const dispatch = useDispatch();
    const {mobileView} = useLayout();

    usePreloadSlideImages();

    useEffect(() => {
        const interval = setInterval(() => {
            dispatch(clockTickAction());
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [dispatch]);

    return (
        <SlideRefContextProvider>
            <ImageMarkupProvider>{mobileView ? <PresentationViewMobile /> : <PresentationViewDesktop />}</ImageMarkupProvider>
        </SlideRefContextProvider>
    );
}

export default PresentationView;
